import { selectFromRouteDto } from '../../models';

export default selectFromRouteDto()
  .name
  .uuid
  .startDate
  .createdOn
  .projectId
  .isLocked
  .deleted
  .isStarted
  .completedStopsCount
  .isDispatched
  .isScheduling
  .isUnscheduling
  .isDeleting
  .solutionId
  .hexColor
  .driver(driver => driver.name.deleted)
  .constraints(constraint => constraint
    .capacity
    .duration
    .startTime
    .endTime
    .startLocations(startLocation => startLocation.latitude.longitude.address)
    .endLocations(endLocation => endLocation.latitude.longitude.address))
  .routePerformanceEvent(event => event.routeTimelineId.visitId.eventType.originalArrivalTime.expectedArrivalTime)
  .activeRouteSolution(routeSolution => routeSolution
    .id
    .stopsCount
    .ordersCount
    .drivingTime
    .distance
    .polyline
    .load
    .distance
    .workingTime
    .finished
    .violations(violation => violation
      .type)
    .routeTimeline(routeTimeline => routeTimeline
      .id
      .routeSolutionId
      .eventType
      .eventUuid
      .orderUuid
      .reattemptEventUuid
      .arrivalTime
      .departureTime
      .startTime
      .endTime
      .stopSequence
      .sequence
      .isArrived
      .isDeparted
      .visitTimeWindowId
      // orders depends on eventUuid, orderUuid
      .orders(order => order
        .uuid
        .isScheduled)
      .violations(violation => violation
        .type)
      // TODO: Refactor stop status, currently needed from logs for timeline
      .logs(log => log
        .status
        .date
        .eventUuid)
      .constraints(routeTimelineConstraints => routeTimelineConstraints
        .latitude
        .longitude)
      .eta(eta => eta
        .originalArrivalTime
        .expectedArrivalTime
        .actualArrivalTime)))
  .toString();
